export { default as component } from "../../../../src/routes/[prefix]/(feature)/event/+page.svelte";